import { __rest } from '../node_modules/tslib/tslib.es6.mjs.js';
import React__default, { useRef, useEffect } from 'react';
import classNames from 'classnames';
import { VideoModal } from './VideoModal.js';
import { LoadPlayer, LoadFilePlayer, LoadUniversalPlayer } from './LoadPlayer.js';
import { ButtonV2 } from '../ButtonV2/ButtonV2.js';
import { AspectRatio } from '../AspectRatio/AspectRatio.js';
import { updateYoutubeURLWithNoCookieVariant } from '@breville/xps-utils/dist/youtube/youtube-nocookie';
import { useWindowSize } from '@breville/xps-utils/core/useWindowSize';
import { BREAKPOINT_MD } from '@breville/xps-utils/core/constants';

const RenderPlayerConditionally = (props) => {
    const { url = '' } = props;
    const isYoutube = typeof url === 'string' && url.indexOf('youtube') > -1;
    const extension = typeof url === 'string' ? url.substring(url.lastIndexOf('.')).toLowerCase() : '';
    const hasValidExtension = ['.mp4', '.webm', '.ogv', '.mp3', '.m3u8', '.mpd'].includes(extension);
    return (React__default.createElement(React__default.Fragment, null,
        isYoutube && React__default.createElement(LoadPlayer, Object.assign({}, props)),
        !isYoutube && hasValidExtension && React__default.createElement(LoadFilePlayer, Object.assign({}, props)),
        !isYoutube && !hasValidExtension && React__default.createElement(LoadUniversalPlayer, Object.assign({}, props))));
};
const RenderVideoModal = (props) => {
    const { playInModal, videoBtnLabel, modalTrigger = 'backgroundImage', aspectRatio = { ratio: '16-9' }, playOnHover, playing } = props;
    const videoProps = Object.assign(Object.assign({}, props), { videoBtnLabel, light: '', playing: true, modalTrigger });
    const containerRef = useRef(null);
    const windowSize = useWindowSize();
    const isMobile = windowSize.width < BREAKPOINT_MD;
    function handlePlayPause(play) {
        var _a;
        const video = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('video');
        if (video) {
            play ? video.play() : video.pause();
        }
    }
    // Play video when in view
    useEffect(() => {
        if (isMobile && containerRef.current && !props.light) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    handlePlayPause(entry.isIntersecting);
                });
            }, { threshold: 0.5 });
            observer.observe(containerRef.current);
            return () => {
                observer.disconnect();
            };
        }
    }, [isMobile]);
    function handleMouseEnter() {
        if (playOnHover) {
            handlePlayPause(true);
        }
    }
    function handleMouseLeave() {
        if (playOnHover) {
            handlePlayPause(false);
        }
    }
    const playVideo = !playOnHover && playing;
    return (React__default.createElement(React__default.Fragment, null,
        !playInModal &&
            React__default.createElement("div", { role: 'none', ref: containerRef, className: 'xps-vp-hover-wrapper', onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
                React__default.createElement(AspectRatio, Object.assign({}, aspectRatio),
                    React__default.createElement(RenderPlayerConditionally, Object.assign({}, props, { playing: playVideo })))),
        playInModal &&
            React__default.createElement(VideoModal, Object.assign({}, props),
                React__default.createElement("div", { className: 'xps-vp-play-in-modal' },
                    React__default.createElement(RenderPlayerConditionally, Object.assign({}, videoProps))))));
};
const VideoPlayer = (props) => {
    const { videoUrl, videoBtnProps = { fill: 'filled', variant: 'white' }, className, options, playerOptions, playInModal = false, modalTrigger } = props, restProps = __rest(props, ["videoUrl", "videoBtnProps", "className", "options", "playerOptions", "playInModal", "modalTrigger"]), { title = 'Play Video', playIconClassName = '' } = options || {}, { playsinline = true, previewTabIndex = -1, controls = true, playing = true, width = '100%', height = '100%', muted = true } = playerOptions || {}, classes = classNames('xps-vp', className), playIconClasses = classNames(playIconClassName);
    return (React__default.createElement(RenderVideoModal, Object.assign({ url: updateYoutubeURLWithNoCookieVariant(videoUrl), className: classes, playIcon: React__default.createElement(ButtonV2, Object.assign({}, videoBtnProps, { text: title, icon: 'play', className: playIconClasses })), playing: playing, playsinline: playsinline, previewTabIndex: previewTabIndex, controls: controls, width: width, height: height, muted: muted }, playerOptions, { playInModal: playInModal, modalTrigger: modalTrigger, videoBtnProps: videoBtnProps, videoBtnLabel: title }, restProps)));
};

export { VideoPlayer, VideoPlayer as default };
//# sourceMappingURL=VideoPlayer.js.map
